const envRegisterOptions = process.env.MIX_REGISTER_OPTIONS as 'both' | 'email' | 'phone';
const envRegisterDefault = process.env.MIX_REGISTER_DEFAULT as 'email' | 'phone';

const readBooleanEnv = (value: string | undefined, fallback: boolean = false) => {
    if (value === undefined || value === null || value === '') {
        return fallback;
    }

    return value === 'true';
};

const authConfig = {
    defaultLanguage: process.env.MIX_LOCALE ?? 'en',
    defaultCountry: process.env.MIX_DEFAULT_COUNTRY ?? 'US',
    registerOptions: ['both', 'email', 'phone'].includes(envRegisterOptions) ? envRegisterOptions : 'email',
    registerDefault: ['email', 'phone'].includes(envRegisterDefault) ? envRegisterDefault : 'email',

    formLoginEnabled: readBooleanEnv(process.env.MIX_FORM_LOGIN_ENABLED),
    formRegisterEnabled: readBooleanEnv(process.env.MIX_FORM_REGISTER_ENABLED),

    captchaLoginEnabled: readBooleanEnv(process.env.MIX_CAPTCHA_LOGIN_ENABLED, true),
    captchaRegisterEnabled: readBooleanEnv(process.env.MIX_CAPTCHA_REGISTER_ENABLED, true),
    captchaCrmLoginEnabled: readBooleanEnv(process.env.MIX_CAPTCHA_CRM_LOGIN_ENABLED, true),
    captchaLostPasswordEnabled: readBooleanEnv(process.env.MIX_CAPTCHA_LOSTPASSWORD_ENABLED, true),
    captchaContactEnabled: readBooleanEnv(process.env.MIX_CAPTCHA_CONTACT_ENABLED, true),
    captchaAffiliateEnabled: readBooleanEnv(process.env.MIX_CAPTCHA_AFFILIATE_ENABLED, true),
    captchaDeactivateAccountEnabled: readBooleanEnv(process.env.MIX_CAPTCHA_DEACTIVATE_ACCOUNT_ENABLED, true),
    captchaChangePasswordEnabled: readBooleanEnv(process.env.MIX_CAPTCHA_CHANGE_PASSWORD_ENABLED, true),
    captchaChangeEmailEnabled: readBooleanEnv(process.env.MIX_CAPTCHA_CHANGE_EMAIL_ENABLED, true),
    captchaChangePhoneEnabled: readBooleanEnv(process.env.MIX_CAPTCHA_CHANGE_PHONE_ENABLED, true),
    turnstileEnabled: readBooleanEnv(process.env.MIX_TURNSTILE_ENABLED),

    registerNameAndLastnameRequired: readBooleanEnv(process.env.MIX_REGISTER_NAME_AND_LASTNAME_REQUIRED),
    registerWithDobAndGender: readBooleanEnv(process.env.MIX_REGISTER_WITH_DATE_OF_BIRTH_AND_GENDER_ENABLED),
    ageConfirmationActive: readBooleanEnv(process.env.MIX_REGISTER_AGE_18_OR_OLDER_CONFIRMATION),
    registerAgeValue: process.env.MIX_REGISTER_AGE_VALUE ?? 18,
    registerWithCpf: readBooleanEnv(process.env.MIX_REGISTER_WITH_CPF_NUMBER),
    registerValidateStrongPassword: readBooleanEnv(process.env.MIX_PASSWORD_STRONG_VALIDATION),
    registerWithPhoneNumber: readBooleanEnv(process.env.MIX_REGISTER_WITH_PHONE_NUMBER),
    registerPasswordConfirmationEnabled: readBooleanEnv(process.env.MIX_REGISTER_PASSWORD_CONFIRMATION_ENABLED),
    registerWithState: readBooleanEnv(process.env.MIX_REGISTER_WITH_STATE_ENABLED, true),

    socialLoginEnabled: readBooleanEnv(process.env.MIX_SOCIAL_LOGIN_ENABLED),
    defaultPhoneCountry: process.env.MIX_DEFAULT_COUNTRY ?? 'US',

    templateName: process.env.MIX_APP_TEMPLATE ?? 'default',
    promoCodeActive: readBooleanEnv(process.env.MIX_PROMO_CODE_ACTIVE),

    phoneVerificationEnabled: readBooleanEnv(process.env.MIX_PHONE_VERIFICATION_ENABLED),
};

export default authConfig;
